import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router';
import { PillButton } from 'src/common/buttons';
import { useAnalyticsContext } from 'src/common/metrics';
import { ScrollableRow } from 'src/common/styled';
const PillCarouselRow = styled(ScrollableRow) `
  && {
    padding: 0 12px;
    margin: 0 -12px !important;
  }
`;
export const RufusPillCarousel = ({ pills, setSelectedQuery, widgetRef, hasScrolledRef, hasClickedRef, isAlexaVariant, }) => {
    const rumClient = useAnalyticsContext();
    const { asin } = useParams();
    const carouselRef = useRef(null);
    useEffect(() => {
        const element = carouselRef.current;
        if (!element)
            return;
        const handleScroll = () => {
            if (!hasScrolledRef.current) {
                hasScrolledRef.current = true;
                rumClient.recordEvent('RUFUS_PILL_CAROUSEL_SCROLL_DEDUPED', {
                    url: window.location.href,
                    asin,
                });
            }
        };
        element.addEventListener('scroll', handleScroll);
        return () => element.removeEventListener('scroll', handleScroll);
    }, [rumClient, asin, hasScrolledRef]);
    const handlePillClick = (questionText) => {
        rumClient.recordEvent('RUFUS_PILL_CLICK', {
            url: window.location.href,
            asin,
        });
        if (!hasClickedRef.current) {
            hasClickedRef.current = true;
            rumClient.recordEvent('RUFUS_PILL_CLICK_DEDUPED', {
                url: window.location.href,
                asin,
            });
        }
        setSelectedQuery(questionText);
        // Scroll to the top of widget in vertical manner if widget is out of viewport on pill click.
        if (widgetRef === null || widgetRef === void 0 ? void 0 : widgetRef.current) {
            const rect = widgetRef.current.getBoundingClientRect();
            const isInViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;
            if (!isInViewport) {
                widgetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    };
    return pills ? (_jsx(PillCarouselRow, { spacing: "300", ref: carouselRef, children: pills.map((pill) => (_jsx(PillButton, { "data-testid": "rufus-pill-button", size: "small", onClick: () => handlePillClick(pill.questionText), alexaVariant: isAlexaVariant, children: pill.questionText }, pill.questionText))) })) : null;
};
